import defaultAttributes from '../defaultAttributes';

const DollarSign = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '12', y1: '1', x2: '12', y2: '23' }],
    ['path', { d: 'M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6' }],
  ],
];

export default DollarSign;
